<template>
  <div id="app">
    <CheckinApp />
  </div>
</template>

<script>
import CheckinApp from './components/CheckinApp.vue'

export default {
  name: 'App',
  components: {
    CheckinApp
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

#app {
  width: 100%;
  max-width: 400px;
}
</style>